import React, { useEffect, useState } from "react";
import { camelCase, isEmpty } from "lodash";
import { Button, Form } from "react-bootstrap";
import {
  CsplTable as Table,
  SliderPanel,
  DatePicker,
  FieldDropSide,
  AddToolTip,
} from "../../../../../components";
import {
  useRequest,
  useRouterParams,
  useDeepEffect,
} from "../../../../../abstracts";
import { getPlansHours } from "../../../../../services";
import AddHours from "./AddHours";
import {
  usDateFormat,
  formFields,
  manageCensusFormNames,
} from "../../../../../utils";
import { Formik, Field } from "formik";
import permissions from "../../../../../mocks/menuPermissions.json";
import authService from "../../../../../components/api-authorization/AuthorizeService";
const columns = [
  {
    label: "Pay date",
    className: "column-payDate",
    columnName: "payDate",
  },
  {
    label: "Pay period hours",
    className: "column-payPeriodHours",
    columnName: "payPeriodHours",
  },
  {
    label: "Updated Through",
    className: "column-updatedThrough",
    columnName: "uploadedThrough",
  },
  {
    label: "Updated By",
    className: "column-updatedBy",
    columnName: "updatedBy",
  },
  {
    label: "Comments",
    className: "column-comments",
    columnName: "comments",
    // link: `link`,
  },
];
//const updatedBy = [null, "Admin"];

var defaultStartDate = new Date();
defaultStartDate.setDate(defaultStartDate.getDate() - 120);
defaultStartDate = usDateFormat(defaultStartDate);
const defaultEndDate = usDateFormat(new Date());
const Hours = (props) => {
  const { menu, subMenu } = props;
  const [filteredResponse] = useState([]);
  const [showHoursForm, setShowHoursForm] = useState(false);
  const [isLoading] = useState(false);
  const { censusId } = useRouterParams();
  const [totalPay, setTotalPay] = useState(0);
  const [hoursList, setHoursList] = useState([]);
  const [toggle, setToggle] = useState(false);
  const formName = manageCensusFormNames.HOURS;
  const fields = formFields[formName];
  const [roleName, setRoleName] = useState("VOU");
  useEffect(() => {
    getRole();
  }, []);
  const getRole = async () => {
    setRoleName(await authService.getRole());
  };
  const subMenuItem =
    permissions[roleName][menu + "SubMenu"]?.[camelCase(subMenu)];
  const isAllowed = (icon, isAddButton) => {
    if (icon === "pencil-alt") {
      return (subMenuItem || "").includes("U") ? true : false;
    } else if (isAddButton) {
      return (subMenuItem || "").includes("C") &&
        (subMenuItem || "").includes("U")
        ? true
        : false;
    } else if (icon === "times") {
      return true;
    }
  };
  useDeepEffect(() => {
    getPlansHours({
      employeeId: parseInt(censusId),
      startDate: defaultStartDate,
      endDate: defaultEndDate,
    }).then((response) => {
      setHoursList(response);
    });
  }, [toggle]);

  var totPayHours = 0;
  if (!isEmpty(hoursList)) {
    hoursList.map((hr, initValue) => {
      totPayHours = totPayHours + hr.payPeriodHours;
    });
  }

  const toggleHoursForm = () => {
    setShowHoursForm(!showHoursForm);
  };

  const onFormSubmit = {};
  const onFilter = (values) => {
    getPlansHours({
      employeeId: parseInt(censusId),
      startDate: values.startDate,
      endDate: values.endDate,
    }).then((response) => {
      setHoursList(response);
    });
  };

  return (
    <>
      {!showHoursForm && (
        <div className="w-100 hours-table">
          <div className="d-flex w-100 align-items-center justify-content-between">
            <div className="plan-sub-heading">Show records of period</div>
            <div className="plan-sub-heading">
              Total Pay Period Hours &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              {totPayHours?.toFixed(2)}
            </div>
          </div>
          {/* <div className="plan-sub-heading">
              Total Pay Period Hours &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{totPayHours}
            </div> */}
          <Formik
            initialValues={{
              startDate: defaultStartDate,
              endDate: defaultEndDate,
            }}
            onSubmit={onFormSubmit}
            enableReinitialize
          >
            {({
              handleChange,
              setFieldValue,
              handleSubmit,
              values,
              ...rest
            }) => {
              const onDaySelected = (fieldName, value) => {
                setFieldValue(fieldName, value);
              };
              return (
                <Form
                  autoComplete="off"
                  className="h-100"
                  onSubmit={handleSubmit}
                  validated={!isEmpty(rest.errors)}
                >
                  <div className="d-flex justify-content-between compensation-container w-100">
                    <div
                      className="d-flex align-items-center justify-content-between hoursHeader"
                      style={{ width: "80%" }}
                    >
                      <Field
                        size="smd"
                        label="Start Date"
                        name={fields.startDate}
                        className="startDate"
                        value={usDateFormat(values[fields.startDate])}
                        isDatePicker
                        onClear={() => onDaySelected(fields.startDate, null)}
                        popupContent={
                          <DatePicker
                            onDayClick={(value) =>
                              onDaySelected(fields.startDate, value)
                            }
                            value={usDateFormat(values[fields.startDate])}
                          />
                        }
                        component={FieldDropSide}
                      />
                      <Field
                        size="smd"
                        label="End Date"
                        name={fields.endDate}
                        value={usDateFormat(values[fields.endDate])}
                        isDatePicker
                        onClear={() => onDaySelected(fields.endDate, null)}
                        popupContent={
                          <DatePicker
                            onDayClick={(value) =>
                              onDaySelected(fields.endDate, value)
                            }
                            value={usDateFormat(values[fields.endDate])}
                          />
                        }
                        component={FieldDropSide}
                      />
                      <Button
                        onClick={() => onFilter(values)}
                        type="button"
                        className="align-center"
                      >
                        Go
                      </Button>
                      <div className="mr-4 mt-12">
                        {/* Total Pay Period Hours {totPayHours} */}
                        {hoursList.length} Record
                      </div>
                    </div>
                    <div className="align-center">
                      {isAllowed("", true) ? (
                        <Button
                          type="button"
                          className="add-btn"
                          onClick={toggleHoursForm}
                          variant="secondary"
                        >
                          Add PayPeriod Hours
                        </Button>
                      ) : null}
                    </div>
                  </div>
                </Form>
              );
            }}
          </Formik>
          <br />

          <Table>
            <Table.Thead>
              <Table.Tr>
                {columns.map((item, index) => {
                  return (
                    <Table.Th key={index} className={item.className}>
                      {item.label}
                    </Table.Th>
                  );
                })}
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {hoursList.map((hours, index) => {
                return (
                  <Table.Tr key={index}>
                    {columns.map((item, cellIndex) => {
                      return (
                        <Table.Td key={cellIndex} className={item.className}>
                          {hours[item.columnName] === null ||
                          hours[item.columnName] === "" ? (
                            "-"
                          ) : item.dataMapper ? (
                            item.dataMapper[hours[item.columnName]]
                          ) : item.columnName === "payDate" ? (
                            usDateFormat(hours[item.columnName])
                          ) : (item.columnName === "updatedBy") |
                            (item.columnName === "comments") ? (
                            <AddToolTip
                              name={hours[item.columnName] || "-"}
                              placement="top"
                            >
                              {hours[item.columnName] || "-"}
                            </AddToolTip>
                          ) : (
                            hours[item.columnName]
                          )}
                        </Table.Td>
                      );
                    })}
                  </Table.Tr>
                );
              })}
            </Table.Tbody>
          </Table>
        </div>
      )}
      {/* {showHoursForm && (
        <AddHours
          {...props}
          toggleHoursForm={toggleHoursForm}
          setToggle={setToggle}
          toggle={toggle}
        />

        
      )} */}
      <SliderPanel isOpen={showHoursForm} size="55" showCancel={false}>
        <div className="d-flex mr-600">
          <AddHours
            {...props}
            toggleHoursForm={toggleHoursForm}
            setToggle={setToggle}
            toggle={toggle}
          />
        </div>
      </SliderPanel>
    </>
  );
};

export default Hours;
